/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export enum StreamType {
  IPTV = "IPTV"
}
